module.exports = __webpack_public_path__ + "img/diary.9a9a4d81.svg";